import React from 'react';
import Typography from '@mui/material/Typography';

export default function NCRFormLabel(props) {
  return (
    <Typography
      component="p"
      className={props.className || 'ncr-form-label'}
      variant={props.variant || 'h3'}
      onClick={props.onClick}
      sx={{
        fontFamily: 'Lato, sans-serif',
        fontSize: props.label === "search-label" ? "14px" : "14px",
        fontWeight: '400',
        lineHeight: '16.8px',
        color: '#000000',
        pr:1,
        ...props.sx,
      }}
    >
      {props.children}
      {props.isRequired && <span style={{
        fontFamily: 'Lato, sans-serif',
        fontSize: '20px',
        fontWeight: '400',
        lineHeight: '16.8px',
        color: 'rgba(255, 0, 0, 1)',
        marginLeft: '2px',
      }}>*</span>}
    </Typography>
  );
}
